import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Button, Col, Form, FormGroup, FormText, Input, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, InputGroup, InputGroupAddon} from 'reactstrap';
import _ from 'lodash';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import {Validacao} from "../../comum/components/Validacao";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import Select from "react-select";
import {createSelectOptions, formatTelefone, getByAtribute, stringToArray} from "../../../utils/formatar";
import NumberFormat from "react-number-format";
import {Alerta} from "../../comum/components/Alerta";
import shortid from "shortid";

@inject("store")
@observer
export class IndicacoesForm extends Component {

    static propTypes = {
        indicacoes: PropTypes.object,
        solicitacaoExcecao: PropTypes.bool,
        adicionarIndicacao: PropTypes.func,
        removerIndicacao: PropTypes.func,
        setCpf: PropTypes.func,
        setNome: PropTypes.func,
        setETTId: PropTypes.func,
        setEmail: PropTypes.func,
        setTelefone: PropTypes.func,
        loading: PropTypes.bool
    };

    constructor(props) {
        super(props);
    }
    render() {
        const ettOptions = createSelectOptions(this.props.controller.etts,"id", "nomeFantasia");

        const indicacoesForm = [];
        for (let i = 0; i < _.get(this.props, "indicacoes.length", 0); i++) {
            if(i === 0 || !this.props.solicitacaoExcecao) {
                const key = this.props.indicacoes[i].key;
                const indicacao = getByAtribute(this.props.indicacoes, key, "key");
                indicacoesForm.push(<LoadingBlockFields key={key} carregando={this.props.controller.isIndicacaoLoading(key)}>
                    {!this.props.solicitacaoExcecao &&
                    <div>
                        <div className="form-subtitle">
                            <div>
                                <span className="subtitle">Indicação {i + 1}</span>
                                <div className="inline-block">
                                    {(i > 0 || this.props.indicacoes.length > 1) &&
                                    <a onClick={() => this.props.removerIndicacao(i)}><FontAwesome name="minus-circle"/></a>
                                    }
                                    <a onClick={() => this.props.adicionarIndicacao(i)}><FontAwesome name="plus-circle"/></a>
                                </div>
                            </div>
                        </div>
                        <hr className="form-subtitle"/>
                    </div>
                    }
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>CPF {(this.props.solicitacaoExcecao || indicacao.nome || indicacao.email || indicacao.telefone) && <sup>*</sup>}</Label>
                                <div>
                                    <NumberFormat className="form-control" format="###.###.###-##" value={indicacao.cpf} onChange={(event, values) => this.props.setCpf(values.value, key)}/>
                                    {(this.props.solicitacaoExcecao || indicacao.nome || indicacao.email || indicacao.telefone) ? (
                                        <Validacao id={"cpfIndicacao"+i} valor={indicacao.cpf} tipo={["isRequired", "isCPF"]} />
                                    ) : (
                                        <Validacao id={"cpfIndicacao"+i} valor={indicacao.cpf} tipo={["isCPF"]} />
                                    )}
                                    {(indicacao.obstrucaoValidacaoCPF && indicacao.obstrucaoValidacaoCPF.length > 0) ? (
                                        <Alerta id={"alertaCpfIndicacao"+i} alertas={indicacao.obstrucaoValidacaoCPF} isBloqueante/>
                                    ) : indicacao.alertaValidacaoCPF && indicacao.alertaValidacaoCPF.length > 0 &&
                                        <Alerta id={"alertaCpfIndicacao"+i} alertas={indicacao.alertaValidacaoCPF} isBloqueante={false}/>
                                    }
                                </div>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Nome {(this.props.solicitacaoExcecao || indicacao.cpf || indicacao.email || indicacao.telefone) && <sup>*</sup>}</Label>
                                <div>
                                    <Input type="text" value={indicacao.nome} maxLength={64} onChange={(event) => this.props.setNome(event.target.value, i)}/>
                                    {(this.props.solicitacaoExcecao || indicacao.cpf || indicacao.email || indicacao.telefone) &&
                                    <Validacao id={"nomeIndicacao"+i} valor={indicacao.nome} tipo={["isRequired"]} />
                                    }
                                </div>
                            </FormGroup>
                        </Col>
                        {this.props.solicitacaoExcecao && (
                            <Col xs={12} md={6} lg={4}>
                                <FormGroup>
                                    <Label>ETT</Label>
                                    <Select simpleValue value={indicacao.ettId}
                                            options={ettOptions}
                                            onChange={(value) => this.props.setETTId(value, i)}
                                            isLoading={this.props.controller.loadingEtts}
                                            noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                            disabled={!this.props.controller.ettExcecaoEditavel}
                                            multi={false}  />
                                </FormGroup>
                            </Col>
                        )}
                    </Row>
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>E-mail {(this.props.solicitacaoExcecao || indicacao.cpf || indicacao.nome) && !indicacao.telefone && <sup>*</sup>}</Label>
                                <div>
                                    <Input type="email" value={indicacao.email} onChange={(event) => this.props.setEmail(event.target.value, i)} />
                                    {(this.props.solicitacaoExcecao || indicacao.cpf || indicacao.nome) && !indicacao.telefone ? (
                                        <Validacao id={"empregado"+i} valor={indicacao.email} tipo={["isRequired", "isEmail"]} />
                                    ) : (
                                        <Validacao id={"empregado"+i} valor={indicacao.email} tipo={["isEmail"]} />
                                    )}
                                </div>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Telefone contato {(this.props.solicitacaoExcecao || indicacao.cpf || indicacao.nome) && !indicacao.email && <sup>*</sup>}</Label>
                                <div>
                                    <NumberFormat className="form-control" maxLength={15} format={(value) => formatTelefone(value)} value={indicacao.telefone} onChange={(event, values) => this.props.setTelefone(values.value, i)}/>
                                    {(this.props.solicitacaoExcecao || indicacao.cpf || indicacao.nome) && !indicacao.email &&
                                    <Validacao id={"telefoneIndicacao"+i} valor={indicacao.telefone} tipo={["isRequired"]} />
                                    }
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                </LoadingBlockFields>)
            }
        }
        return (
            <div>
                {_.get(this.props, "indicacoes.length", 0) > 0 &&
                    <div>
                        {this.props.solicitacaoExcecao ? (
                            <h4>Indicação</h4>
                        ) : (
                            <h4>Indicações para o processo de seleção</h4>
                        )}
                        {indicacoesForm}
                        <Validacao id="indicacoesUnicas" valor={this.props.controller.apenasCpfIndicacoes}
                                   tipo={["isArrayUnique"]} />
                    </div>
                }
            </div>
        )
    }
}